import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { matchPath } from 'react-router-dom';

const LanguageRouter = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const pathname = location.pathname;

  // List of public routes that don't need language prefix
  const publicRoutes = [
    '/login',
    '/login/frasers',
    '/login/nt',
    '/signup',
    '/verify',
    '/set-up-company',
    '/forget-password',
    '/reset-password',
    '/invitation',
    '/event-survey',
    '/event-controller',
    '/event-dashboard',
    '/event-survey-completed',
    '/privacy-policy',
    '/blank',
    '/esg/:companyId/view/:key',
    '/testing',
  ];

  useEffect(() => {
    // Extract language from path
    const langMatch = pathname.match(/^\/(en|th|jp)/);
    if (langMatch) {
      const pathLang = langMatch[1];
      // If URL language doesn't match current i18n language, update the URL
      if (pathLang !== i18n.language) {
        const newPath = pathname.replace(`/${pathLang}/`, `/${i18n.language}/`);
        navigate(newPath, { replace: true });
      }
    }
  }, [i18n.language, pathname, navigate]);

  // Check if the current path is a public route
  const isPublicRoute = publicRoutes.some(route => {
    // For routes with parameters (containing ':')
    if (route.includes(':')) {
      return matchPath({ path: route }, pathname) !== null;
    }
    // For exact routes
    return pathname === route || pathname.startsWith(route + '/');
  });

  // Only redirect to language prefix for non-public routes
  if (!isPublicRoute && !pathname.match(/^\/(en|th|jp)/)) {
    const defaultLang = 'en';
    const newPath = `/${defaultLang}${pathname}`;
    return <Navigate to={newPath} replace />;
  }
  return children;
};

export default LanguageRouter; 